var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileColpleteAvadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75 17.5C8.29822 17.5 5.5 20.2982 5.5 23.75C5.5 25.8211 7.17894 27.5 9.25 27.5H21.75C23.8211 27.5 25.5 25.8211 25.5 23.75C25.5 20.2982 22.7017 17.5 19.25 17.5H11.75Z",
    fill: "#292D34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5 2.5C12.0482 2.5 9.25 5.29822 9.25 8.75C9.25 12.2018 12.0482 15 15.5 15C18.9517 15 21.75 12.2018 21.75 8.75C21.75 5.29822 18.9517 2.5 15.5 2.5Z",
    fill: "#292D34"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileColpleteAvadar);
export default __webpack_public_path__ + "static/media/profile-colplete-avadar.519ce89c217425f47127a517e8a69a27.svg";
export { ForwardRef as ReactComponent };